export const TEMPLATE_TYPE = {
  TTL: 'TTL',
  PUSH: 'PUSH',
  BANNER: 'BANNER'
}

export const DEFAULT_ROUTES_BY_TEMPLATE ={
  'TTL': {
    mainActiveRoute: 'panel',
    subActiveRoute: 'previewDesktop'
  },
  'PUSH': {
    mainActiveRoute: 'panelPush',
    subActiveRoute: 'previewPush'
  },
  'BANNER': {
    mainActiveRoute: 'panelBanner',
    subActiveRoute: 'previewBanner'
  }
}

export const DYNAMIC_PARAMS = 10;

export const LINK_URL_QUERY_PARAMS = {
	LENGTH: 5,
	NAMES: ['sfmc_p1', 'sfmc_p2', 'sfmc_p3', 'sfmc_p4', 'sfmc_p5']
}

export const SIZE_OPTIONS = [
  { id: 'small', description: 'small' },
  { id: 'medium', description: 'medium' },
  { id: 'large', description: 'large' },
  { id: 'app-mobile', description: 'app mobile' }
]

export const PRIORITY_BANNER_OPTIONS = [
  { id: 0, description: 'Seleziona...' },
  { id: 5, description: '5' },
  { id: 4, description: '4' },
  { id: 3, description: '3' },
  { id: 2, description: '2' },
  { id: 1, description: '1' }
]

export const BOX_NUMBER_OPTIONS = [
  { id: '', description: 'Seleziona...' },
  { id: 'BOX1', description: 'Box 1' },
  { id: 'BOX2', description: 'Box 2' },
  { id: 'BOX3', description: 'Box 3' }
]

export const MAX_CHAR_LIMIT_3 = 3;
export const MAX_CHAR_LIMIT_15 = 15;
export const MAX_CHAR_LIMIT_20 = 20;
export const MAX_CHAR_LIMIT_65 = 65;
export const MAX_CHAR_LIMIT_75 = 75;